module.exports = __webpack_public_path__ + "static/media/26-2.68bc7062.mp3";